export const FILE_EXTENSIONS = {
  DOC: 'doc',
  DOCX: 'docx',
  XLS: 'xls',
  XLSX: 'xlsx',
  CSV: 'csv',
  PPTX: 'pptx',
  PPT: 'ppt',
  XML: 'xml',
  MSG: 'msg',
  DWG: 'dwg',
  DXF: 'dxf',
  STL: 'stl',
  DFT: 'dft',
  PAR: 'par',
  IGS: 'igs',
  X_T: 'x_t',
  STEP: 'step',
  STP: 'stp',
  ZIP: 'zip',
  GLB: 'glb',
  PDF: 'pdf',
  UNKNOWN_FILE_EXTENSION: 'unknownFileExtension',
};

export const FILE_EXTENSION_ICON_CONFIG = new Map([
  [
    [FILE_EXTENSIONS.DOC, FILE_EXTENSIONS.DOCX],
    {
      icon: 'docx',
      getWidth: (small) => (small ? 27 : 48),
      getHeight: (small) => (small ? 27 : 48),
    },
  ],
  [
    [FILE_EXTENSIONS.XLS, FILE_EXTENSIONS.XLSX],
    {
      icon: 'xlsx',
      getWidth: (small) => (small ? 27 : 48),
      getHeight: (small) => (small ? 27 : 48),
    },
  ],
  [
    [FILE_EXTENSIONS.CSV],
    {
      icon: 'csv',
      getWidth: (small) => (small ? 27 : 48),
      getHeight: (small) => (small ? 27 : 48),
    },
  ],
  [
    [FILE_EXTENSIONS.PPTX, FILE_EXTENSIONS.PPT],
    {
      icon: 'pptx',
      getWidth: (small) => (small ? 27 : 48),
      getHeight: (small) => (small ? 27 : 48),
    },
  ],
  [
    [FILE_EXTENSIONS.XML],
    {
      icon: 'xml',
      getWidth: (small) => (small ? 27 : 48),
      getHeight: (small) => (small ? 27 : 48),
    },
  ],
  [
    [FILE_EXTENSIONS.MSG],
    {
      icon: 'xlsx',
      getWidth: (small) => (small ? 33.8 : 46.8),
      getHeight: (small) => (small ? 26 : 36),
    },
  ],
  [
    [FILE_EXTENSIONS.DWG, FILE_EXTENSIONS.DXF],
    {
      icon: 'dwg',
      getWidth: (small) => (small ? 27 : 48),
      getHeight: (small) => (small ? 27 : 48),
      withWrapper: (small) => !small,
      color: 'System/Light/Purple',
    },
  ],
  [
    [
      FILE_EXTENSIONS.STL,
      FILE_EXTENSIONS.DFT,
      FILE_EXTENSIONS.PAR,
      FILE_EXTENSIONS.IGS,
      FILE_EXTENSIONS.X_T,
      FILE_EXTENSIONS.STEP,
      FILE_EXTENSIONS.STP,
    ],
    {
      icon: 'stl',
      getWidth: (small) => (small ? 23 : 40.6),
      getHeight: (small) => (small ? 26 : 45.6),
      getBackgroundColor: (small) => (small ? null : 'Gray/Light/6'),
      withWrapper: (small) => !small,
      color: 'System/Light/Purple',
    },
  ],
  [
    [FILE_EXTENSIONS.ZIP],
    {
      icon: 'zip',
      getWidth: (small) => (small ? 6.6 : 11.7),
      getHeight: (small) => (small ? 26.4 : 47.9),
      getBackgroundColor: (small) => (small ? null : 'Gray/Light/6'),
      withWrapper: (small) => !small,
      wrapperStyles: { alignItems: 'flex-start' },
      color: 'System/Light/Brown',
    },
  ],
  [
    [FILE_EXTENSIONS.PDF],
    {
      icon: 'pdf',
      getWidth: (small) => (small ? 21.4 : 38),
      getHeight: (small) => (small ? 28.7 : 51),
      color: 'Label/Light/Quaternary',
    },
  ],
  [
    [FILE_EXTENSIONS.UNKNOWN_FILE_EXTENSION],
    {
      icon: 'unknownFileExtension',
      getWidth: (small) => (small ? 19 : 37.7),
      getHeight: (small) => (small ? 25 : 48),
    },
  ],
]);

export const getConfigByExtension = (extension: string) => {
  for (const [extensions, config] of FILE_EXTENSION_ICON_CONFIG) {
    if (Array.isArray(extensions) && (extensions.includes(extension) || extensions.includes(FILE_EXTENSIONS.UNKNOWN_FILE_EXTENSION))) {
      return config;
    }
  }

  return null;
};

export const fileFormatNames = {
  '3ds': '3D Studio MAX file',
  bmp: 'BMP image',
  c3d: 'C3D file',
  catpart: 'CATIA file',
  CATScript: 'CATIA Macro',
  dae: 'COLLADA file',
  dgn: 'Microstation file',
  dgn: 'MicroStation DGN file',
  doc: 'Microsoft Word document',
  docx: 'Microsoft Word document',
  dwf: 'DWF file',
  dwg: 'AutoCAD drawing',
  dxf: 'DXF drawing',
  gif: 'GIF image',
  hgl: 'HPGL file',
  IGES: '3D intermediate file',
  ipt: 'Autodesk Inventor file',
  jpeg: 'PNG image',
  jpg: 'JPEG image',
  jt: 'JT file',
  log: 'LOG file',
  lsp: 'LSP file',
  obj: 'OBJ (WaveFront)',
  par: 'Solid Edge drawing',
  pdf: 'PDF document',
  png: 'PNG image',
  prt: 'NX',
  sldprt: 'Solid Works drawing',
  step: 'Step file',
  stl: 'STL file',
  stp: 'Step file',
  svg: 'Scalable Vector Graphics file',
  swb: 'Solid Works Macro',
  tif: 'TIF image',
  tiff: 'TIF image',
  x_b: 'Parasolid Binary file',
  x_t: 'Parasolid Text file',
  xls: 'Microsoft Excel document',
  xlsx: 'Microsoft Excel document',
  abc: 'ABC file',
  txt: 'Text file',
};
